import { Col, Divider, Row } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import useIsMobile from "../../../biblio/mobileVersion/useIsMobile";

interface HeroSectionDetailsProjectProps
  extends React.HTMLAttributes<HTMLDivElement> {
  urlImage: string;
  title: string;
  subTitle: string;
  mobileImage?: string;
  type?: "المشاريع" | "تفريج كرب" | "التبرع العام";
}
const HeroSectionDetailsProject = ({
  urlImage,
  mobileImage,
  title,
  subTitle,
  type,
  ...props
}: HeroSectionDetailsProjectProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const handleNavigation = () => {
    const path =
      title === "الأخبار" ? "/news" : title === "البرامج" ? "/programs" : "/";
    navigate(path, {
      state: {
        type: type,
      },
    });
  };

  return (
    <section
      {...props}
      className={`takaful--hero-section-details-project ${
        props.className ?? ""
      }`}
      style={{ backgroundImage: `url(${isMobile ? mobileImage : urlImage})` }}
    >
      <Row align="middle" className="takaful--details-project-text">
        <Col
          xxl={12}
          xl={12}
          lg={24}
          md={24}
          sm={24}
          xs={24}
          className="takaful--details-project-content"
        >
          <p
            className="takaful--hero-section-details-project-title"
            onClick={handleNavigation}
          >
            {title}
          </p>
          <Divider
            type="vertical"
            className="takaful--details-project-divider"
          />
          <span>{subTitle}</span>
        </Col>
      </Row>
    </section>
  );
};

export default HeroSectionDetailsProject;
